var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-bar",style:({'height': _vm.statusBarHeight + 'px'})})
}
var staticRenderFns = []

export { render, staticRenderFns }